import React from 'react';
import { LogoContainer, CollabX } from './styles';
import { Picture } from '../Picture';

export function Logos() {
  return (
    <LogoContainer aria-hidden="true">
      <Picture
        imagePath="/anchor-logo-header"
        alt="Anchor logo"
        className="anchorLogo"
      />
      <CollabX>X</CollabX>
      <Picture
        imagePath="/wordpress/logo-white"
        alt="WordPress logo"
        className="wpLogo"
      />
    </LogoContainer>
  );
}
